import React, { useMemo, useState } from 'react';
import {
  PageHeading,
  Table,
  Text,
} from 'barte-design-system';
import type { ColumnDefinition } from 'barte-design-system';
import { PortalPayfacsLayout } from '../PortalPayfacsLayout';
import { CadastrarPlano } from './CadastrarPlano';
import { DetalhePlano } from './DetalhePlano';
import './PlanoTaxas.css';

// ─── Types ────────────────────────────────────────────────────────────────────

interface PlanoTaxa {
  id: number;
  nome: string;
  totalVendedores: number | null;
}

// ─── Mock data ────────────────────────────────────────────────────────────────

const ALL_PLANOS: PlanoTaxa[] = [
  { id: 33, nome: 'Plano seller 4821', totalVendedores: 3 },
  { id: 34, nome: 'Plano - TESTE GUSTAVO - Ar Fusion Brasil LTDA - 2025-09-03', totalVendedores: 1 },
  { id: 40, nome: 'Plano Zero Template', totalVendedores: 0 },
  { id: 52, nome: 'Plano - Euroluce comercio imp e exp de equip de ilum ltda - 2025-09-15', totalVendedores: 7 },
  { id: 57, nome: 'Plano - Allugator Serviços Digitais LTDA - 2025-09-15', totalVendedores: 2 },
  { id: 58, nome: 'Plano - EXP GROUP ASSESSORIA E PARTICIPACOES LTDA - 2025-09-15', totalVendedores: 5 },
  { id: 59, nome: 'Plano - Razor Technologies do Brasil Ltda - 2025-09-15', totalVendedores: 4 },
  { id: 60, nome: 'Plano - DESINCHA COMERCIO DE PRODUTOS NATURAIS LTDA. - 2025-09-15', totalVendedores: 12 },
  { id: 61, nome: 'Plano - YOUVISA TECNOLOGIA DE VIAGENS LTDA - 2025-09-15', totalVendedores: 1 },
  { id: 62, nome: 'Plano - EXP SAUDE CLINICA MEDICA LTDA - 2025-09-15', totalVendedores: 8 },
  { id: 63, nome: 'Plano - Tech Ventures Brasil - 2025-09-20', totalVendedores: 3 },
  { id: 64, nome: 'Plano - Grupo Comercial Alpha LTDA - 2025-09-20', totalVendedores: 6 },
  { id: 65, nome: 'Plano - Norte Distribuidora S.A. - 2025-09-22', totalVendedores: 9 },
  { id: 66, nome: 'Plano - Farma Saúde e Bem Estar - 2025-09-25', totalVendedores: 2 },
  { id: 67, nome: 'Plano - Construção Forte LTDA - 2025-09-28', totalVendedores: 14 },
  { id: 68, nome: 'Plano - Agro Sul Exportações - 2025-10-01', totalVendedores: 0 },
  { id: 69, nome: 'Plano - Digital Pay Solutions - 2025-10-03', totalVendedores: 5 },
  { id: 70, nome: 'Plano Bronze Padrão', totalVendedores: 22 },
];

// ─── Columns ──────────────────────────────────────────────────────────────────

const COLUMNS: ColumnDefinition<PlanoTaxa>[] = [
  {
    key: 'id',
    title: 'ID',
    dataIndex: 'id',
    width: 80,
    render: (value) => <Text variant="body-sm">{value as number}</Text>,
  },
  {
    key: 'nome',
    title: 'Nome do Plano',
    dataIndex: 'nome',
    render: (value) => <Text variant="body-sm">{value as string}</Text>,
  },
  {
    key: 'totalVendedores',
    title: 'Total de Vendedores',
    dataIndex: 'totalVendedores',
    width: 180,
    render: (value) => (
      <Text variant="body-sm">{(value as number) ?? '—'}</Text>
    ),
  },
];

// ─── Component ────────────────────────────────────────────────────────────────

export function PlanoTaxas() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [criando, setCriando] = useState(false);
  const [selectedPlano, setSelectedPlano] = useState<PlanoTaxa | null>(null);

  const pagedData = useMemo(() => {
    const start = (page - 1) * pageSize;
    return ALL_PLANOS.slice(start, start + pageSize);
  }, [page, pageSize]);

  const totalPages = Math.ceil(ALL_PLANOS.length / pageSize);

  if (criando) {
    return <CadastrarPlano onBack={() => setCriando(false)} />;
  }

  if (selectedPlano) {
    return <DetalhePlano plano={selectedPlano} onBack={() => setSelectedPlano(null)} />;
  }

  return (
    <PortalPayfacsLayout activeItem="plano-taxas">
      <main className="content">
        <div className="content-inner">
            <PageHeading
              title="Plano de Taxas"
              primaryActionLabel="Criar Plano"
              onPrimaryAction={() => setCriando(true)}
            />

            <div className="content-table">
              <Table
                data={pagedData}
                columns={COLUMNS}
                rowKey={(r) => r.id}
                onRowClick={(record) => setSelectedPlano(record)}
                pagination={{
                  currentPage: page,
                  totalPages,
                  onPageChange: setPage,
                  pageSize,
                  pageSizeOptions: [10, 25, 50],
                  onPageSizeChange: (size) => { setPageSize(size); setPage(1); },
                }}
              />
            </div>
          </div>
      </main>
    </PortalPayfacsLayout>
  );
}
